"use client";

import { createContext, use, type ReactNode } from "react";

export type IslandSlotName =
  | "docsOutline"
  | "docsMobileOutline"
  | "tool"
  | "listingStaffBar"
  | "listingTrackers"
  | "listingHeaderActions"
  | "listingGallery"
  | "listingRail"
  | "listingRecentlyViewed";

export type IslandSlots = Partial<Record<IslandSlotName, ReactNode>>;

export const IslandSlotsContext = createContext<IslandSlots>({});

export function IslandSlot({ name, children }: { name: IslandSlotName; children: ReactNode }) {
  const slots = use(IslandSlotsContext);
  return slots[name] ?? children;
}
